import { PRIVACY_POLICY_SECTIONS } from "./privacyPolicyContent";
import { getRefundSignupLegalBody } from "./refundPolicyContent";
import { RISK_DISCLAIMER_SECTIONS } from "./riskDisclaimerContent";
import { TERMS_AND_CONDITIONS_SECTIONS } from "./termsAndConditionsContent";

function sectionsToSignupBody(sections) {
  return sections.map((s) => `${s.title}: ${s.body}`);
}

/**
 * Sign-up modal legal excerpts — built from the same modules as the public legal pages.
 * Edit `src/legal/*Content.js` and `refundPolicyContent.js` to update both the site pages and this modal.
 */
export const SIGNUP_LEGAL_DOCUMENTS = {
  terms: {
    title: "Terms & Conditions",
    body: sectionsToSignupBody(TERMS_AND_CONDITIONS_SECTIONS),
  },
  risk: {
    title: "Risk Disclaimer",
    body: sectionsToSignupBody(RISK_DISCLAIMER_SECTIONS),
  },
  privacy: {
    title: "Privacy Policy",
    body: sectionsToSignupBody(PRIVACY_POLICY_SECTIONS),
  },
  refund: {
    title: "Refund Policy",
    body: getRefundSignupLegalBody(),
  },
};
